'use client';

import React from 'react';
import { AgencyCandidatesGuard } from '@/doi-tac-module/components/agency-candidates-guard';
import { CandidateSearchClient } from '@/doi-tac-module/components/tim-ung-vien/CandidateSearchClient';

interface CandidatesViewProps {
  initialCandidates: any[];
  totalCount: number;
  currentPage: number;
  totalPages: number;
  allAgencies: any[];
  userContext: any;
  isTrash?: boolean;
}

export function CandidatesView({
  initialCandidates,
  totalCount,
  currentPage,
  totalPages,
  allAgencies,
  userContext,
  isTrash = false
}: CandidatesViewProps) {
  return (
    <AgencyCandidatesGuard>
      <CandidateSearchClient
        initialCandidates={initialCandidates}
        totalCount={totalCount}
        currentPage={currentPage}
        totalPages={totalPages}
        agencies={allAgencies}
        currentUser={userContext}
        isTrash={isTrash}
        isAgency={true}
      />
    </AgencyCandidatesGuard>
  );
}
